import { AxiosInstance } from 'axios';
import alphaRealEstate from './alphaRealEstate';

const SITE_NAME: string = process.env.REACT_APP_SITE_NAME as string;
const requestMap: { [key: string]: AxiosInstance } = {
  'alpha-real-estate': alphaRealEstate,
};

const requestInstance = requestMap[SITE_NAME] || requestMap['alpha-real-estate'];

export default requestInstance;
